import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@rocketlane/ui';
import styled, { css } from 'styled-components';
const ActionButtonComponent = ({ className, title, onClick, disabled, variant, danger, dataCy })=>/*#__PURE__*/ _jsx(Button, {
        className: className,
        size: "medium",
        variant: danger ? 'danger' : variant !== null && variant !== void 0 ? variant : 'ghost',
        type: "button",
        onClick: onClick,
        disabled: disabled,
        "data-cy": dataCy !== null && dataCy !== void 0 ? dataCy : `action-panel.footer.btn.${title}`,
        children: title
    });
// Interpolated, not a class selector: the package base class is `rl-btn`, so a
// `.rl-button` rule silently matched nothing and every footer lost its spacing.
const ActionButton = styled(ActionButtonComponent)``;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${({ $reverse })=>$reverse ? 'row-reverse' : 'row'};

  ${ActionButton} {
    padding: 0 calc(var(--spacing-05) - 1px);
    ${({ $reverse })=>!$reverse && css`
        margin-right: var(--spacing-02);
      `};
    ${({ $reverse })=>$reverse && css`
        margin-left: var(--spacing-02);
      `};

    &:last-child {
      margin: 0;
    }
  }
`;
const ActionFooterComponent = ({ className, primary, secondary, other = [], reverse })=>/*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        $reverse: !!reverse,
        "data-cy": "action-panel.footer.wrapper",
        children: [
            /*#__PURE__*/ _jsx(ActionButton, {
                dataCy: "action-panel.footer.primary-btn",
                ...primary
            }),
            secondary == null ? null : /*#__PURE__*/ _jsx(ActionButton, {
                dataCy: "action-panel.footer.secondary-btn",
                ...secondary
            }),
            other.map((action, idx)=>/*#__PURE__*/ _jsx(ActionButton, {
                    ...action
                }, idx))
        ]
    });
export const ActionFooter = styled(ActionFooterComponent)``;
